import { takeLatest } from "redux-saga/effects";

import * as ActionsTypes from "../../../../common/state/StatesConstants";
import { getMeSaga, getSearchSaga } from "./SearchSaga";

export default function* SearchWatcher() {
  yield takeLatest(ActionsTypes.GET_SEARCH, getSearchSaga);
  yield takeLatest(ActionsTypes.ME, getMeSaga);
}